import { Component} from '@angular/core';

@Component({
  selector: 'app-salinity-vertical-header',
  standalone: false,
  templateUrl: './salinity-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class SalinityVerticalHeaderComponent {

}
